import { Link } from "react-router-dom";
import { navLinks, siteName } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-primary-800 bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-primary-950 text-lg">
                <i className="ri-fire-fill" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100">
              面向火影忍者爱好者的动漫专题资料站，提供剧集剧情介绍、角色资料分析与最新动漫资讯，
              帮助你更完整地走进忍者世界。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-primary-200">
              站内导航
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-100 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-primary-200">
              关注我们
            </h4>
            <p className="mt-4 text-sm leading-relaxed text-primary-100">
              内容均基于公开信息整理与原创撰写，仅用于动漫文化交流与资料查阅。
            </p>
            <div className="mt-4 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100 transition-colors hover:bg-accent-500 hover:text-primary-950 cursor-pointer"
                >
                  <i className={icon} />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-primary-200 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} {siteName}. 保留所有权利。</p>
          <p>本站为动漫资料展示平台，不提供在线观看、下载等任何功能。</p>
        </div>
      </div>
    </footer>
  );
}